/* Naturealm Tools: Questions library. Topic filter, search, deep links, copy link, ask-a-question to Klaviyo. */
(function () {
  var root = document.querySelector('[data-nq]');
  if (!root) return;
  var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
  var items = $$('[data-nq-item]');
  var groups = $$('[data-nq-group]');
  var chips = $$('[data-nq-topic]');
  var offer = root.querySelector('[data-nq-offer]');
  var search = root.querySelector('[data-nq-search]');
  var countEl = root.querySelector('[data-nq-count]');
  var emptyEl = root.querySelector('[data-nq-empty]');
  var topic = '';
  var searchTimer;

  function push(evt, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      data = data || {}; data.event = evt;
      window.dataLayer.push(data);
    } catch (e) {}
  }

  function apply() {
    var q = (search && search.value || '').trim().toLowerCase();
    var n = 0;
    items.forEach(function (it) {
      var okTopic = !topic || it.getAttribute('data-topic') === topic;
      var okText = !q || it.textContent.toLowerCase().indexOf(q) > -1;
      var show = okTopic && okText;
      it.classList.toggle('is-hidden', !show);
      if (show) n++;
      var more = it.querySelector('[data-nq-more]');
      if (more && q && show) more.open = true;
    });
    groups.forEach(function (g) {
      g.classList.toggle('is-hidden', !g.querySelector('[data-nq-item]:not(.is-hidden)'));
    });
    if (offer) offer.classList.toggle('is-hidden', !!(q || topic));
    if (countEl) countEl.textContent = n + (n === 1 ? ' question' : ' questions');
    if (emptyEl) emptyEl.hidden = n > 0;
  }

  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      topic = c.getAttribute('data-nq-topic');
      chips.forEach(function (x) {
        var on = x === c;
        x.classList.toggle('is-on', on);
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      apply();
      push('questions_topic', { topic: topic || 'all' });
    });
  });

  if (search) search.addEventListener('input', function () {
    apply();
    clearTimeout(searchTimer);
    var v = search.value.trim();
    if (v.length > 2) searchTimer = setTimeout(function () { push('questions_search', { term: v }); }, 1200);
  });

  items.forEach(function (it) {
    var more = it.querySelector('[data-nq-more]');
    if (more) more.addEventListener('toggle', function () {
      if (more.open) push('question_opened', { question: (it.querySelector('.nq-q') || {}).textContent });
    });
  });

  // Copy a link to one answer
  $$('[data-nq-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var url = location.origin + location.pathname + '#' + b.getAttribute('data-nq-copy');
      var done = function () {
        b.textContent = 'Link copied';
        b.classList.add('is-done');
        setTimeout(function () { b.textContent = 'Copy link'; b.classList.remove('is-done'); }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () { history.replaceState(null, '', '#' + b.getAttribute('data-nq-copy')); done(); });
      } else {
        history.replaceState(null, '', '#' + b.getAttribute('data-nq-copy')); done();
      }
      push('question_link_copied', { id: b.getAttribute('data-nq-copy') });
    });
  });

  // Open an answer from a #hash link, e.g. /pages/mushroom-questions#what-s-in-sacred-7
  function openHash() {
    if (!location.hash || location.hash.length < 2) return;
    var t;
    try { t = root.querySelector('#' + CSS.escape(decodeURIComponent(location.hash.slice(1)))); } catch (e) { return; }
    if (!t || !t.hasAttribute('data-nq-item')) return;
    var more = t.querySelector('[data-nq-more]');
    if (more) more.open = true;
    items.forEach(function (x) { x.classList.remove('is-target'); });
    t.classList.add('is-target');
    setTimeout(function () { t.scrollIntoView({ block: 'start' }); }, 50);
  }
  window.addEventListener('hashchange', openHash);
  openHash();

  // Ask a question: Klaviyo client event (+ optional newsletter subscribe)
  var ask = root.querySelector('[data-nq-ask]');
  var form = root.querySelector('[data-nq-ask-form]');
  if (ask && form) {
    var key = ask.getAttribute('data-kl-key');
    var list = ask.getAttribute('data-kl-list');
    var msg = form.querySelector('[data-nq-ask-msg]');
    var btn = form.querySelector('button[type="submit"]');
    var qEl = form.querySelector('[name="question"]');
    var eEl = form.querySelector('[name="email"]');
    var say = function (t, ok) { msg.textContent = t; msg.className = 'nq-ask__msg ' + (ok ? 'is-ok' : 'is-err'); };
    var headers = { 'content-type': 'application/vnd.api+json', revision: '2024-10-15' };

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var question = qEl.value.trim();
      var email = eEl.value.trim();
      qEl.classList.toggle('is-error', question.length < 5);
      eEl.classList.toggle('is-error', !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
      if (question.length < 5) { say('Add your question first.'); qEl.focus(); return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { say('That email doesn’t look right.'); eEl.focus(); return; }
      if (!key) { say('Something went wrong. Email us instead.'); return; }
      btn.disabled = true; btn.textContent = 'Sending…';

      var base = 'https://a.klaviyo.com/client/';
      var q = '?company_id=' + encodeURIComponent(key);
      var calls = [fetch(base + 'events/' + q, {
        method: 'POST', headers: headers,
        body: JSON.stringify({ data: { type: 'event', attributes: {
          properties: { question: question, page: location.pathname, source: 'Questions library' },
          metric: { data: { type: 'metric', attributes: { name: 'Asked a Question' } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        } } })
      })];
      if (form.querySelector('[name="newsletter"]').checked && list) {
        calls.push(fetch(base + 'subscriptions/' + q, {
          method: 'POST', headers: headers,
          body: JSON.stringify({ data: { type: 'subscription', attributes: {
            custom_source: 'Questions library',
            profile: { data: { type: 'profile', attributes: { email: email, properties: { signup_source: 'Questions library' } } } }
          }, relationships: { list: { data: { type: 'list', id: list } } } } })
        }));
      }
      Promise.all(calls).then(function (res) {
        if (!res[0].ok) throw new Error('Klaviyo ' + res[0].status);
        say('Got it. We’ll email you when it’s answered.', true);
        form.reset();
        push('question_asked', {});
      }).catch(function () {
        say('That didn’t send. Please try again in a minute.');
      }).then(function () {
        btn.disabled = false; btn.textContent = 'Send my question';
      });
    });
  }

  apply();
})();
